export default {
    blog: {
        Search: 'Search',
        posts: ' Posts',
        column: 'Column View',
        list: 'List View',
        toggle: 'toggle view style',
        noFilter: 'No Filter',
        article: 'article',
        minRead: ' min read',
        articles: 'Articles',
        disc: 'NobleWills has prepared these guides and articles in good faith and are intended to be used as a guide only. None of its statements, claims, or contents should be construed as advice or a recommendation. Inclusion of the name, logo or other identification of any companies on this platform does not constitute endorsement or recommendations of the goods or services of those companies.',
        tempDisc:
            'DISCLAIMER: This article is for general information only and does not constitute legal advice. While many simple estates can be managed using reliable online Will-writing tools, more complex situations may require tailored advice from a professional.',
    },
};
